import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProductIntro() {
  return <section className="py-10 md:py-24 bg-charcoal relative overflow-hidden" data-id="element-265">
      {/* Decorative background elements */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-sand/5 rounded-full blur-3xl pointer-events-none" data-id="element-266"></div>

      <div className="max-w-3xl mx-auto px-6 relative z-10 text-center" data-id="element-267">
        <FadeIn data-id="element-268">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-offwhite mb-8" data-id="element-269">
            <span className="text-sand" data-id="element-270">RESET 7D</span> es un plan de 7 días
            diseñado para que volvás a vos.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-271">
          <div className="space-y-4 text-xl text-offwhite-dim font-light mb-12" data-id="element-272">
            <p data-id="element-273">No es una dieta.</p>
            <p data-id="element-274">No es un plan de entrenamiento.</p>
            <p data-id="element-275">No es un curso de meditación.</p>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-276">
          <div className="bg-charcoal-dark border border-sand/30 p-8 md:p-12 rounded-sm shadow-[0_0_40px_rgba(212,165,116,0.05)]" data-id="element-277">
            <p className="text-2xl md:text-3xl font-heading font-bold text-amber mb-6 leading-tight" data-id="element-278">
              Es un sistema integrado (Cuerpo + Alma) con tracker diario para
              que no pierdas el hilo.
            </p>
            <p className="text-lg text-offwhite-dim" data-id="element-279">
              Simple. Medible. Con acompañamiento real por WhatsApp.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}